import React from 'react'

type InputProps = {
  labelName: string
  htmlfor: string
  type: string
  inputMode?: string
  placeholder?: string
  register: any
  pattern?: RegExp
  validate?: Record<string, (value: string) => boolean | string>
  minLength?: number
  required?: boolean
  onChange?: () => void
  require?: boolean
  ariaLabel?: string
  accept?: string
  sm?: boolean
  defaultValue?: string
}

const Input = ({
  labelName,
  htmlfor,
  type,
  inputMode,
  placeholder,
  register,
  pattern,
  validate,
  minLength,
  required,
  onChange,
  require,
  ariaLabel,
  sm,
  defaultValue,
}: InputProps) => {
  return (
    <div>
      <label htmlFor={htmlfor} className={`text-gray-600 mt-3 block font-bold ${sm ? 'text-[12px]' : 'text-sm'}`}>
        {labelName}
        {require ? '*' : ''}
      </label>
      <input
        aria-label={ariaLabel || ''}
        id={htmlfor}
        type={type}
        name={htmlfor}
        placeholder={placeholder || ''}
        autoComplete={htmlfor}
        className="c-input c-placeholder_text-size"
        defaultValue={defaultValue}
        inputMode={inputMode}
        {...register(htmlfor, {
          pattern,
          validate,
          minLength,
          required,
          onChange,
        })}
      />
    </div>
  )
}

export default Input
